import { AccountConstants } from '@/constants';

const getters = {
  activeQueue: (state) => {
    return state.queue.slice(0, AccountConstants.MAX_DISPLAYED_NOTIFICATIONS);
  },
};

export { getters };
